/**
 * Uploads sometimes stored the login email (TQ106746@centa.org) instead of the bare id (TQ106746).
 * Scorecards are keyed by the bare id, so compare and send ids through this.
 */
export const toCandidateId = (id: any): string => String(id ?? '').trim().replace(/@centa\.org$/i, '')

export const isSameCandidate = (a: any, b: any): boolean => !!a && !!b && toCandidateId(a) === toCandidateId(b)

/** Both stored forms of an id, for DB filters that must hit rows saved either way. */
export const candidateIdVariants = (id: any): string[] => {
  const bare = toCandidateId(id)
  return bare ? [bare, `${bare}@centa.org`] : []
}
